<div class="card">
    <h1>Økonomisk støtte</h1>
    <p class="description">Trenger du økonomisk veiledning? Banken din, NAV eller kommunen kan gi råd og hjelpe deg med å finne løsninger som passer din situasjon.</p>
</div>
